import { Dashboard } from "./BusinessDataHub";

/** The same single-page business hub is used on mobile; MobileLayout owns navigation. */
export const MobileDashboard = () => <Dashboard />;
